import { render } from "./SpeakerSection.vue?vue&type=template&id=596ebc7c&scoped=true&ts=true"
import script from "./SpeakerSection.vue?vue&type=script&lang=ts"
export * from "./SpeakerSection.vue?vue&type=script&lang=ts"

import "./SpeakerSection.vue?vue&type=style&index=0&id=596ebc7c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596ebc7c"]])

export default __exports__